import { saveErrorReason } from "@components/CatalogIndex";
import type { BatchFailure } from "@components/CatalogIndex";
import type { Governance } from "../../types/Governance";

// Both loops take mutations that REJECT on failure (RTK's .unwrap()). The v1
// versions awaited the raw result, which resolves with { error }, so a 403 or
// 422 was reported as a success.

/** Deletes in parallel; returns one failure per id that did not delete. */
export const deleteGovernances = async (
  ids: string[],
  governances: Governance[],
  destroy: (id: string) => Promise<unknown>
): Promise<BatchFailure[]> => {
  const results = await Promise.allSettled(ids.map((id) => destroy(id)));
  return results.flatMap((result, index) =>
    result.status === "rejected"
      ? [
          {
            label: governances.find((g) => String(g.id) === ids[index])
              ?.description,
            reason: saveErrorReason(result.reason),
          },
        ]
      : []
  );
};

/** Saves moved rows' positions in order, stopping at the first failure. */
export const saveGovernancePositions = async (
  governances: Governance[],
  move: (id: string, position: number) => Promise<unknown>
): Promise<{ error: unknown }> => {
  for (const governance of governances.filter((g) => g?.isChanged)) {
    try {
      await move(String(governance.id), Number(governance.position));
    } catch (error) {
      return { error };
    }
  }
  return { error: null };
};
